module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-1-sp@2x_06a48e7578ac3ecb265702a5395dfaaf.png";